import React from 'react'

const Error = () => {
  return (
    <div className='h-screen flex flex-col justify-center'>
        <div className='text-9xl text-center'>
        Error 404 page not found
        </div>
    </div>
  )
}

export default Error